import { Box, Skeleton } from "@mui/material";
import { QuickRepliesSkeleton } from "../QuickReplies";

const InstantBookingSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: { xs: 1, md: "initial" },
      }}
    >
      {/* Panel title */}
      <Skeleton
        variant="text"
        width="72%"
        height={34}
        sx={{ mb: 2, display: { xs: "none", sm: "block" } }}
      />
      <Skeleton
        variant="text"
        width="55%"
        height={23}
        sx={{ mb: 3, display: { xs: "none", sm: "block" } }}
      />

      <Box
        data-booking-step-content
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: { xs: 1, md: "initial" },
          height: { xs: "auto", md: 550 },
          minHeight: { xs: "auto", md: 550 },
        }}
      >
        <Box sx={{ flex: 1 }} />

        <Box>
          <Box sx={{ mb: 0.25 }}>
            <Skeleton variant="text" width={42} height={18} />
          </Box>

          {/* Opening question + AI topic chips */}
          <Skeleton variant="text" width="75%" height={22} />
          <Box sx={{ mb: 2 }}>
            <QuickRepliesSkeleton />
          </Box>

          <Box sx={{ position: "relative" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={54}
              sx={{ borderRadius: "9999px" }}
            />
            <Skeleton
              variant="circular"
              width={32}
              height={32}
              sx={{ position: "absolute", right: 8, bottom: 11 }}
            />
          </Box>
          <Skeleton
            variant="text"
            width="62%"
            height={18}
            sx={{ display: { xs: "none", sm: "block" }, mt: 1 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default InstantBookingSkeleton;
